/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_LEVEL } from "./actionTypes"
import { apiError, addLevelSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addLevel } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(addLevel, action.payload.form)
    if (response == undefined) throw new Error("API error")
    if (!response.success) throw new Error("Error al guardar el nivel")
    yield put(addLevelSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* levelAddSaga() {
  yield takeEvery(ADD_LEVEL, add)
}

export default levelAddSaga
